import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MenuManagementService } from '../menu/services/menu-management.service';
import { NavaidsService } from '../services/navaids.service';



@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {


  @Output() footerStateChange = new EventEmitter<any>();


  constructor(public navaidsController: NavaidsService,
    public menuService: MenuManagementService
    ) { }

  ngOnInit(): void {
    console.log();
  }

  onTabsStateChange(event: {active: boolean, minimized: boolean}) {
    this.footerStateChange.emit(event);
  }

}
